import "react-toastify/dist/ReactToastify.css";
import Notification from "@components/ui/Notification";
import React, { ReactNode } from "react";
import { ToastOptions, toast } from "react-toastify";

export const useNotification = () => {
  const notification = {
    success: (
      title: string,
      message?: ReactNode,
      options?: ToastOptions<unknown> | undefined
    ) => {
      toast(
        <Notification title={title} variant="success">
          {message}
        </Notification>,
        {
          ...options,
        }
      );
    },
    warning: (
      title: string,
      message?: ReactNode,
      options?: ToastOptions<unknown> | undefined
    ): void => {
      toast(
        <Notification title={title} variant="warning">
          {message}
        </Notification>,
        {
          ...options,
        }
      );
    },
    info: (
      title: string,
      message?: ReactNode,
      options?: ToastOptions<unknown> | undefined
    ) => {
      toast(
        <Notification title={title} variant="info">
          {message}
        </Notification>,
        {
          ...options,
        }
      );
    },
    error: (
      title: string,
      message?: ReactNode,
      options?: ToastOptions<unknown> | undefined
    ) => {
      toast(
        <Notification title={title} variant="error">
          {message}
        </Notification>,
        {
          ...options,
        }
      );
    },
  };
  return notification;
};
